import * as React from "react";
import type { SVGProps } from "react";
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#filter_svg__a)">
      <path d="M5 22c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M5 14c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1M19 14c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1M12 22c-.55 0-1-.45-1-1V11c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1M12 8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M19 22c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1" />
      <path d="M5 18c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1M19 18c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1M12 12c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
    </g>
    <defs>
      <clipPath id="filter_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFilter;
